import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { SettingsFacade } from 'app/modules/dashboard/facades/settings.facade';
import { UserFacade } from 'app/modules/dashboard/facades/user.facade';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_URL_V4, environment } from 'src/environments/environment.local';

import { User, UserInformation } from '../models';
import { AuthService } from './auth.service';
import { CookieConsentService } from './cookie-consent.service';
import { Store } from '@ngrx/store';
import { MeActions } from 'app/store/me/me.actions';

export interface UserInfoResult {
  data: User;
}

@Injectable({ providedIn: 'root' })
export class UserService {
  private storedUser: User;
  public currentUser: EventEmitter<any> = new EventEmitter();

  constructor(
    private readonly http: HttpClient,
    private readonly userFacade: UserFacade,
    private readonly authService: AuthService,
    private readonly cookies: CookieConsentService,
    private readonly settingsFacade: SettingsFacade,
    private readonly store: Store
  ) { }

  deleteAvatar(): Observable<any> {
    return this.http
      .delete(environment.api.user.deleteAvatar)
      .pipe(map((res) => res));
  }

  disconnect() {
    this.authService.removeUserToken();
    this.userFacade.reset();
    this.cookies.deleteCookie('KINOMAP_AUTH');
    this.store.dispatch(MeActions.clear());
  }

  get() {
    if (this.userFacade.isLoaded() || this.userFacade.isLoading()) {
      return this.userFacade.user$;
    }
    this.userFacade.loadUserInformation();
    return this.userFacade.user$;
  }

  getSettings(): Observable<any> {
    if (this.settingsFacade.isLoaded()) {
      return this.settingsFacade.settings$;
    }
    this.settingsFacade.load();
    return this.settingsFacade.settings$;
  }

  getStoredUser(): User {
    return this.storedUser;
  }

  getSubscription(): Observable<any> {
    return this.http
      .get(`${API_URL_V4}/me/subscription/getV2`)
      .pipe(map((res) => res));
  }
  getUiAvatar(): Observable<any> {
    return this.http
      .get(environment.api.user.getUiAvatar)
      .pipe(map((res) => res));
  }

  recoverPassword(userInfo): Observable<any> {
    return this.http
      .post(environment.api.user.recoverPassword, { login: userInfo })
      .pipe(map((res) => res));
  }

  set(user: Partial<User>): void {
    this.userFacade.updateUser(user);
  }

  updateAvatar(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('avatar', file);
    return this.http
      .post(environment.api.user.updateAvatar, formData)
      .pipe(map((res) => res));
  }

  updateInfos(info: UserInformation): Observable<any> {
    return this.http
      .post(environment.api.user.updateInfos, info)
      .pipe(map((res) => res));
  }
}
